 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTEBB from '@/components/Text/ebb'
 import TEXTTLU from '@/components/Text/tlu'
 import TEXTMM from '@/components/Text/mm'
 import TEXTLOVE_1 from '@/components/Text/love_1'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTDED from '@/components/Text/ded'
 import TEXTACK from '@/components/Text/ack'
 import TEXTAUT from '@/components/Text/aut'
 import TEXTFM1 from '@/components/Text/fm1'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTCH1 from '@/components/Text/ch1'
 import TEXTCH2 from '@/components/Text/ch2'
 import TEXTCH3 from '@/components/Text/ch3'
 import TEXTCH4 from '@/components/Text/ch4'
 import TEXTCH5 from '@/components/Text/ch5'
 import TEXTCH6 from '@/components/Text/ch6'
 import TEXTCH7 from '@/components/Text/ch7'
 import TEXTCH8 from '@/components/Text/ch8'
 import TEXTCH9 from '@/components/Text/ch9'
 import TEXTCH10 from '@/components/Text/ch10'
 import TEXTCH11 from '@/components/Text/ch11'
 import TEXTCH12 from '@/components/Text/ch12'
 import TEXTCH13 from '@/components/Text/ch13'
 import TEXTCH14 from '@/components/Text/ch14'
 import TEXTCH15 from '@/components/Text/ch15'
 import TEXTCH16 from '@/components/Text/ch16'
 import TEXTCH17 from '@/components/Text/ch17'
 import TEXTCH18 from '@/components/Text/ch18'
 import TEXTCH19 from '@/components/Text/ch19'
 import TEXTCH20 from '@/components/Text/ch20'
 import TEXTLOVE_2 from '@/components/Text/love_2'
 import TEXTTEASER00 from '@/components/Text/teaser00'
 import TEXTTEASER01COVER from '@/components/Text/teaser01-cover'
 import TEXTTEASER01 from '@/components/Text/teaser01'
 import TEXTTEASER02 from '@/components/Text/teaser02'
 import TEXTTEASER03 from '@/components/Text/teaser03'
 import TEXTBIO from '@/components/Text/bio'
 import TEXTCRT from '@/components/Text/crt'
 import TEXTSERIESAD from '@/components/Text/seriesad'
 import TEXTORIMAD from '@/components/Text/ORIMad'
 import TEXTSTANDALONE_BA from '@/components/Text/standalone_ba'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/ch1",
 			"name" : "Text/ch1",
 			"component" : TEXTCH1
 		},
 		{
 			"path" : "/Text/ch2",
 			"name" : "Text/ch2",
 			"component" : TEXTCH2
 		},
 		{
 			"path" : "/Text/ch3",
 			"name" : "Text/ch3",
 			"component" : TEXTCH3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js